<template lang="pug">
    .index
        .left
            .box.mb20
                .title 市场雷达
                Recommend
            .box
                .cards(ref="cards")
                    .title 我的地盘
                    router-link(to='/aoi')
                        el-button(icon="el-icon-circle-plus-outline") 新建兴趣区
                .map-container(:style="{paddingBottom: '600px'}")
                    POLYGON_MAP(:height="600" :aoi="aoi" :product="product" :location="location")
                    el-select.aois(v-if="aoi" :value="aoi.id" filterable placeholder="请选择" @change="aoiChange" size="small")
                        el-option(v-for="item in aoiList"
                            :key="item.id"
                            :label="item.name || item.id"
                            :value="item.id")
                    Search.poi-search(@select="changeLocation")
                    .clear
                    .products
                        .products-container
                            dl(v-for="(item, index) in products" :key="item.id" :class="{ on: item.id == product.id }" @click="carouselChange(index)")
                                dt.date-str {{item.date_str}}
                                dd
                                    img(:src="item.image")

        .right.msg-box.box
            dl
                dt 面积
                dd {{area && (area / 1e6).toFixed(2) || 0}} 平方公里
            dl(v-if="aoi && aoi.relations && aoi.relations.length")
                dt 关联实体
                dd.row(v-for="item in aoi.relations" :key="item.value")
                    router-link(v-if="relationStocks[item.value]" :to="`/stock/${item.value}`") {{relationStocks[item.value].name}}
                    router-link(v-else :to="`/stock/${item.value}`") {{item.value}}
                    //- a(href="javascript:;")
                    //-     i.el-icon-close &nbsp;
                    //-     | 解除关联
                    el-popconfirm(title="即将解除与该股票的关联" @confirm="disAssociation(item)")
                        el-button(size="mini" icon="el-icon-close" slot="reference") 解除关联
            dl
                dt 兴趣区操作
                dd.tr
                    el-popconfirm(title="兴趣区删除后不可恢复，您确定要删除么？" @confirm="removeAoi(aoi.id)")
                        el-button(size="mini" type="danger" icon="el-icon-delete" slot="reference" plain) 删除兴趣区

</template>

<script>
import POLYGON_MAP from '../components/map/polygon.vue';
import storeMixin from '../store/mixin';
import area from '@turf/area';
// import CandleStick from '../components/candlestick-mini.vue';
import Search from '../components/map/search.vue';
import Recommend from '../components/recommend.vue';

export default {
    // components: { POLYGON_MAP, CandleStick, Search },
    components: { POLYGON_MAP, Search, Recommend },
    mixins: [storeMixin],
    name: 'AoiIndex',
    data() {
        return {
            aoiList: null,
            aoi: null,
            loading: false,
            products: null,
            product: null,
            indexList: null,
            location: null,
            relationStocks: {},
        };
    },
    created() {
        console.log('created');
        this.getAois();
    },
    computed: {
        area() {
            if (!this.aoi) return;
            return area({
                type: 'Feature',
                properties: {},
                geometry: JSON.parse(this.aoi.geometry_geojson),
            }).toFixed(2);
        },
    },
    mounted() {},
    methods: {
        async getAois() {
            if (this.loading) return;
            this.loading = true;
            try {
                const result = await this.REQUEST({
                    url: 'v2/aoi/list?limit=-1',
                });
                this.aoiList = result.data.items;
                this.aoi = result.data.items[0];
                this.getProducts();
                if (this.aoi.relations && this.aoi.relations.length) {
                    this.aoi.relations.forEach(relation => {
                        if (relation.type == 'stock')
                            this.getStockInfo(relation.value);
                    });
                }
            } catch (e) {
                console.log(e);
            }
            this.loading = false;
        },
        changeLocation(location) {
            this.location = location;
        },
        async getProducts() {
            const products = await this.REQUEST({
                url: `v2/aoi/product/list?aoi_id=${this.aoi.id}`,
            });
            if (!products.data.items) return;
            this.products = products.data.items.filter(item => item.built);
            this.product = this.products[0];
        },
        carouselChange(index) {
            this.product = this.products[index];
        },
        aoiChange(id) {
            this.aoi = this.aoiList.filter(item => item.id == id)[0];
            if (this.aoi.relations && this.aoi.relations.length) {
                this.aoi.relations.forEach(relation => {
                    if (relation.type == 'stock')
                        this.getStockInfo(relation.value);
                });
            }

            this.getProducts();
        },

        async getStockInfo(code) {
            if (this.relationStocks[code]) return;
            try {
                const result = await this.REQUEST({
                    url: `v2/finance/stock/list?q=${code}&limit=30`,
                });
                this.relationStocks = {
                    ...this.relationStocks,
                    [code]: result.data.items[0],
                };
            } catch (e) {
                console.log(e);
            }
        },
        async disAssociation({ type, value }) {
            try {
                const result = await this.REQUEST({
                    url: `v2/aoi/relation`,
                    method: 'DELETE',
                    data: {
                        aoi_id: this.aoi.id,
                        type: type,
                        value: value,
                    },
                });
                this.$message({
                    message: '操作成功',
                    type: 'success',
                });
                this.aoi = {
                    ...this.aoi,
                    ...{
                        relations: this.aoi.relations.filter(
                            item => item.value != value
                        ),
                    },
                };

                let curIndex = this.aoiList.findIndex(
                    aoi => aoi.id == this.aoi.id
                );
                this.aoiList.splice(curIndex, 1, this.aoi);
            } catch (e) {
                console.log(e);
                this.$message({
                    message: '操作失败，请稍候再试',
                    type: 'warning',
                });
            }
        },
        async removeAoi(id) {
            try {
                const result = await this.REQUEST({
                    url: `v2/aoi`,
                    method: 'DELETE',
                    data: {
                        id,
                    },
                });
                this.aoi = null;
                await this.getAois();
                this.$message({
                    message: '删除成功',
                    type: 'success',
                });
            } catch (e) {
                console.log(e);
                this.$message({
                    message: '删除失败，请稍候再试',
                    type: 'warning',
                });
            }
        },
    },
};
</script>

<style lang="stylus" scoped>
.title
    display flex
    align-items center
    font-size 1.2em
    margin-bottom 10px
    i
        margin-right 10px
a
    color #fff
.index
    display flex
    width 100%
.left
    flex-shrink 1
    flex-grow 1
    position relative

.cards
    margin-bottom 40px
    display flex
    justify-content space-between

.products
    position absolute
    left 20px
    right 20px
    bottom 80px
    overflow auto
    .products-container
        display flex
    dl
        position relative
        cursor pointer
        margin 20px

        img
            max-height 100px
            max-width 160px
            border-radius 10px
            box-shadow 0 0 3px 1px #333
        &.on
            img
                box-shadow 0 0 3px 1px #3b56ce
    dt
        position absolute
        width 100%
        bottom 10px
        font-size 12px
        line-height 26px
        text-align center
        user-select none
    &::-webkit-scrollbar
        width 6px
        height 6px
        background-color #F5F5F5

    /*定义滚动条轨道
    内阴影+圆角*/
    &::-webkit-scrollbar-track
        -webkit-box-shadow inset 0 0 6px rgba(0,0,0,0.3)
        border-radius 2px
        // background-color #F5F5F5
    /*定义滑块
    内阴影+圆角*/
    &::-webkit-scrollbar-thumb
        border-radius 2px
        -webkit-box-shadow inset 0 0 6px rgba(0,0,0,.3)
        // background-color #555

.aois
    margin 30px auto 0 30px
    display inline-block
.poi-search
    margin 30px 30px 0 auto
    display inline-block
    float right
.right
    width 300px
    margin-left 40px
.msg-box
    padding 20px 0
    dl
        margin 0 20px 20px 20px
    dt
        font-size 1.2rem
        border-bottom 1px solid #252631
        padding-bottom 10px
        margin-bottom 10px
    dd
        color #767a8c
        font-size 0.9rem
        &.row
            display flex
            justify-content space-between
            margin-bottom 10px
    a
        color #fff
</style>
